module.exports = __webpack_public_path__ + "img/round_car_icon.68c875ae.svg";